import React, { useState } from 'react';
import ReactTable from 'react-table'
import numeral from "numeral";
import moment from "moment";

const AdminUserTransactionTable = props => {
    const columns = [{
        Header: '#',
        Cell: ({row,original}) => row._index+1,
        maxWidth: 75,
        className:'text-center',
        headerClassName: 'text-center'
    },{
        Header: 'DESKRIPSI',
        accessor: 'id',
        minWidth: 200
    },{
        Header: 'STATUS',
        maxWidth: 120,
        accessor: 'referenceId'
    },{
        Header: 'CATEGORY',
        maxWidth: 200,
        accessor: 'paymentCategory'
    },{
        Header: 'METHOD',
        maxWidth: 200,
        accessor: 'paymentMethod'
    },{
        Header: 'TYPE',
        maxWidth: 200,
        accessor: 'type'
    },{
        Header: 'STATUS',
        maxWidth: 200,
        accessor: 'status',
        Cell: ({row,original}) => statusCell(original)
    },{
        Header: 'JUMLAH',
        maxWidth: 120,
        accessor: 'amount',
        Cell: ({row,original}) => amountCell(original.amount)
    },{
        Header: 'BALANCE',
        maxWidth: 200,
        accessor: 'balance',
        Cell: ({row,original}) => amountCell(original.balance)
    },{
        Header: 'WAKTU DIBUAT',
        accessor: 'createdAt',
        headerStyle: { 'whiteSpace': 'unset'},
        maxWidth: 200,
        style: { 'whiteSpace': 'unset'},
        Cell: ({row, original}) => moment(row.createdAt).format("YYYY-MM-DD HH:mm")
    }];

    const amountCell = (amount) => {
        return (
            <div>
                Rp. {numeral(amount).format("0,0")}
            </div>
        )
    };

    const statusCell = (og) => {
        let status;
        if (og.status === 'pending') {
            status = (
                <div className="text-warning">
                    <b>pending</b>
                </div>
            )
        } else if (og.status === 'succeeded') {
            status = (
                <div className="text-success">
                    <b>succeeded</b>
                </div>
            )
        } else if (og.status === 'failed') {
            status = (
                <div className="text-muted">
                    failed
                </div>
            )
        }
        return (
            <div>
                {status}
            </div>
        )
    };

    return (
        <div>
            <ReactTable
                data={props.data}
                columns={columns}
                defaultPageSize={50}
                filterable
                loading={props.loading}
                className="-striped -highlight"
            />
        </div>
    )
};

export default AdminUserTransactionTable;
